module.exports = __webpack_public_path__ + "pigmentace_3_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_3_after_tn.jpg
// module id = 1441
// module chunks = 0